import { Card } from "./Card";

var template = require('./patient_speaker_card.twig');

export class PatientSpeakerCard extends Card {
    constructor() {
        super();
        this.dom = $(twig({ data: template }).render());

        this.rqt_patient_spkr_dd = this.dom.find('.rqt_patient_spkr_dd');
        this.rqt_patient_spkr_dd.on('change', () => {
            if (this.rqt_patient_spkr_dd.val() !== '') {
                this.rqt_patient_spkr_dd.removeClass('required is-invalid');
            } else {
                this.rqt_patient_spkr_dd.addClass('required is-invalid');
            }
            this.cardFilledOutTriggers();
        });
    }

    show() {
        super.show();
    }

    getData() {
        return this.dom.find('.rqt_patient_spkr_dd').val() ?? null
    }
}
